import { useState, useEffect, useRef } from 'react';
import StepHeader from './StepHeader';
import { Box } from '@mui/material';
import Step1 from './Stpe1/Step1';

const CompanySetup = () => {
  const [activeStep, setActiveStep] = useState(0);
  const previousStepRef = useRef<number>(0);

  // Placeholder for getCompanyDetails function - replace with actual implementation
  const getCompanyDetails = async () => {
    // TODO: Implement getCompanyDetails function
    console.log('getCompanyDetails called');
  };

  useEffect(() => {
    const previousStep = previousStepRef.current;
    const currentStep = activeStep;

    // If step changed from 2 to 1, call getCompanyDetails
    if (previousStep === 2 && currentStep === 1) {
      getCompanyDetails();
    }
    // If step changed from 1 to 2, don't call getCompanyDetails (do nothing)

    // Update the previous step reference
    previousStepRef.current = currentStep;
  }, [activeStep]);

  return (
    <Box>
      <StepHeader activeStep={activeStep} onStepChange={(step) => setActiveStep(step)} />

      {activeStep === 0 ? <Step1 /> : null}
    </Box>
  );
};

export default CompanySetup;
